import React, { Component } from 'react';
import DashMenuItem from "../../components/Admin/dashMenuItem";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { newMessage } from '../../slices/modalSlice';
import NewMessage from './newMsgModal';
class MsgHeader extends Component {
  constructor(props) {
    super(props);
   
}
    render() {
        return (
        <>
       
        <div className="msg__menu mt-5 row">
             <div className="col-3 px-0">
                 <div onClick={this.props.newMessage}>
                   <DashMenuItem  txt="Nouveau Message" icon="/imgs/dash/add__fill.svg" size="70px" />
                 </div>
             </div>
             <div className="col-9 d-flex justify-content-between">
                <DashMenuItem txt="Professionnels" icon="/imgs/dash/pro.svg" size="70px" />
                <DashMenuItem txt="Particuliers" icon="/imgs/dash/b2c.svg" size="70px" />
                <DashMenuItem txt="Admin" icon="/imgs/dash/admin_menu.svg" size="70px" />
                <DashMenuItem txt="Non-Lus" icon="/imgs/dash/unread.svg" size="70px" />
                <DashMenuItem txt="Msg. Lus" icon="/imgs/dash/read.svg" size="70px" />
                <DashMenuItem txt="Archive" icon="/imgs/dash/archive.svg" size="70px" />
                <DashMenuItem txt="Corbeille" icon="/imgs/dash/trash.svg" size="70px" />
             </div>
        </div>
        </>
        );
    }
}

const mapDispatchToProps =  {
    newMessage
  }


export default withRouter(connect(null,mapDispatchToProps)(MsgHeader));